<div class="patient-dashboard">
  <!-- Loading spinner -->
  <div class="loading-container" *ngIf="loading">
    <mat-spinner [diameter]="50" color="primary"></mat-spinner>
  </div>

  <!-- Main content when loaded -->
  <div class="dashboard-content" *ngIf="!loading">
    <!-- Welcome header -->
    <div class="welcome-banner" *ngIf="patient?.firstName">
      <div class="welcome-text">
        <h1>Welcome, {{patient.firstName}}</h1>
        <p class="welcome-subtitle">Here's your patient dashboard</p>
      </div>
    </div>

    <!-- Main dashboard sections -->
    <div class="dashboard-grid">
      <!-- Account summary card -->
      <div class="dashboard-card account-card" *ngIf="accountAgingBalance">
        <div class="card-header">
          <h2>
            <mat-icon>account_balance_wallet</mat-icon>
            Account Summary
          </h2>
        </div>

        <div class="card-body">
          <div class="balance-overview">
            <div class="balance-amount">
              <span class="balance-label">Your Current Balance</span>
              <span class="balance-value">{{ accountAgingBalance.PatEstBal | currency }}</span>

              <button *ngIf="accountAgingBalance?.Total > 0" mat-raised-button class="pay-button" (click)="submitPaymentForm()">
                <mat-icon>payment</mat-icon> Pay Now
              </button>
            </div>
          </div>
          <div class="no-balance-message" *ngIf="accountAgingBalance.Total <= 0">
            <mat-icon>check_circle</mat-icon>
            <p>Your account is paid in full. Thank you!</p>
          </div>
        </div>

        <div class="card-footer">
          <button mat-raised-button color="primary" [routerLink]="['/dashboard', 'account-history']">
            <span>View Account Details</span>
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
      </div>

      <!-- Clinic information card -->
      <div class="dashboard-card clinic-card" *ngIf="clinicInfo">
        <div class="card-header">
          <h2>
            <mat-icon>local_hospital</mat-icon>
            Your Clinic
          </h2>
        </div>
        <app-clinic-info></app-clinic-info>
      </div>
    </div>
  </div>
</div>